import { secondsStringToHoursNumber } from '@/vue/helpers/handleTime';
import { tankSortOptions, temperatureSortOptions } from '@/vue/static/installationsTableConstants';
import { getDifference } from '@/vue/helpers/sorters';

export function propValid(site, property) {
    return site && site.data && site.data[property] && site.data[property].rawValue !== null;
}

export function propRead(site, property, key = 'formattedValue') {
    const { data } = site;
    return data[property] ? data[property][key] : null;
}

export function createPropReader(property, key = 'formattedValue') {
    return site => propRead(site, property, key);
}

export function siteIsOld(site) {
    // Returns true if the installation has not been online within the last ~3 months
    // Usage of Date here is not reactive, but since the threshold is at 3 months it doesn't need to be updated
    const recentThreshold = new Date().getTime() / 1000 - 60 * 60 * 24 * 30 * 3;
    return site.last_timestamp < recentThreshold;
}

export function createPropReaderStringToNumber(property, key = 'formattedValue') {
    return site => {
        const value = propRead(site, property, key);
        return value ? secondsStringToHoursNumber(value) : null;
    };
}

export function stateFromErrorAndData(column, site, neutralResult = '') {
    return column.hasError(site) ? 'error' : column.hasData(site) ? neutralResult : 'disabled';
}

export function getSafeInstancesProp(attribute, instance, fallback, typeOfValue = 'rawValue') {
    if (!attribute || !attribute.instances || !attribute.instances[instance]) {
        return fallback;
    }
    const value = attribute.instances[instance][typeOfValue];
    return value === null || value === undefined ? fallback : value;
}

export function getSortedByTypeAndValue(
    listOfValues,
    sortAttribute,
    sortedReverse,
    labelValue,
    typeValue,
    sortOptions,
) {
    if (!Object.values(sortOptions).includes(sortAttribute)) {
        return listOfValues;
    }
    const options = sortAttribute.split(',');

    const valuesWithSortType = listOfValues
        .filter(item => options.includes(item[typeValue]))
        .sort((itemA, itemB) => {
            return getDifference(itemA[labelValue], itemB[labelValue], sortedReverse);
        });
    const valuesWithoutSortType = listOfValues
        .filter(item => !options.includes(item[typeValue]))
        .sort((itemA, itemB) => {
            return getDifference(itemA[labelValue], itemB[labelValue], sortedReverse);
        });
    return [...valuesWithSortType, ...valuesWithoutSortType];
}

export function getTanksSortedByTypeAndPercentage(listOfTanks, sortAttribute, sortedReverse) {
    return getSortedByTypeAndValue(
        listOfTanks,
        sortAttribute,
        sortedReverse,
        'fillPercentage',
        'fluidType',
        tankSortOptions,
    );
}

export function getTemperaturesSortedByTypeAndValue(
    listOfTemperature,
    sortAttribute,
    sortedReverse,
) {
    return getSortedByTypeAndValue(
        listOfTemperature,
        sortAttribute,
        sortedReverse,
        'temperature',
        'type',
        temperatureSortOptions, // TODO: types of temperature sorts
    );
}
